import type { FaireProductEntity } from "../../entity_types/product";

export const p_e87egkwqjz: FaireProductEntity = {
  token: "p_e87egkwqjz",
  type: "product",
  name: "Tahitian Keshi Kites",
  brandName: "Keshi Co",
  imageUrl:
    "https://cdn.faire.com/fastly/3ec9aab5ba82061874bc177404692442032a56748cbd89d53a5b11274d2af564.png",
  priceDollars: 65,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65de55d61f2157e94627836176b1b34c246c1571b4c9ba2895598bf9b7500744.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
